import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/lib/sentry";
import { registerSW } from "@/serviceWorkerRegistration";
import { applyLastKnownTheme } from "@/lib/theme";

initSentry();
// 첫 페인트 전 직전 테마 즉시 주입(블루→앰버 플래시 방지). 기본은 CSS 변수 기본값.
applyLastKnownTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const ErrorFallback = () => (
  <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:24,background:"#F7F8FA"}}>
    <div style={{maxWidth:420,textAlign:"center"}}>
      <h1 style={{fontSize:22,fontWeight:900,color:"#111827"}}>일시적인 오류가 발생했어요</h1>
      <p style={{color:"#6B7280",marginTop:8,fontSize:14}}>잠시 후 다시 시도해 주세요. 문제가 계속되면 새로고침해 주세요.</p>
      <button onClick={() => window.location.reload()} style={{marginTop:16,padding:"10px 18px",borderRadius:12,background:"#2563EB",color:"#fff",border:0,fontWeight:800,cursor:"pointer"}}>새로고침</button>
    </div>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

registerSW();
